"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const complex_utils_1 = require("complex-utils");
class MenuData {
    constructor(initOption) {
        this.load = 'un';
        this.list = [];
        this.menu = [];
        this.current = [];
        this.collapsed = false;
        this.$getData = initOption.$getData;
        this.$addRouter = initOption.$addRouter;
    }
    $loadData() {
        if (this.load === 'end') {
            return Promise.resolve({ status: 'loaded' });
        }
        else {
            return new Promise((resolve, reject) => {
                this.load = 'ing';
                this.$getData().then(() => {
                    this.$addRouter();
                    this.menu = this.$formatMenu(this.list);
                    this.load = 'end';
                    resolve({ status: 'success' });
                }).catch(err => {
                    // eslint-disable-next-line no-console
                    console.error(err);
                    this.load = 'un';
                    reject(err);
                });
            });
        }
    }
    $formatData(menuList, deep = 0) {
        const list = [];
        menuList.forEach((menuItem) => {
            const nameList = menuItem.path.split('/');
            nameList.shift();
            const item = {
                path: menuItem.internalOrExternal ? '$url:' + 'https:/' + menuItem.path : menuItem.path,
                name: nameList.map(nameItem => (0, complex_utils_1.upperCaseFirstChar)(nameItem)).join(''),
                redirect: menuItem.redirect,
                component: menuItem.component,
                children: menuItem.children ? this.$formatData(menuItem.children, deep + 1) : undefined,
                meta: {
                    name: menuItem.name,
                    type: menuItem.type === undefined ? 'router' : menuItem.type,
                    tile: !!menuItem.tile,
                    title: menuItem.title,
                    icon: menuItem.icon,
                    menu: menuItem.menu === undefined ? true : menuItem.menu,
                    keepAlive: menuItem.keepAlive,
                    internalOrExternal: menuItem.internalOrExternal,
                    hidden: menuItem.hidden,
                    tab: menuItem.tab,
                    unauthorized: menuItem.unauthorized,
                    developing: menuItem.developing
                }
            };
            if (item.meta.type !== 'router') {
                item.path = '$' + item.meta.type + ':' + item.path;
            }
            if (menuItem.role) {
                list.push(item);
            }
            else {
                list.push(item);
            }
        });
        return list;
    }
    $formatMenu(menuList) {
        const list = [];
        for (let i = 0; i < menuList.length; i++) {
            const menuItem = menuList[i];
            if (menuItem.meta.menu && !menuItem.meta.hidden) {
                const item = Object.assign({}, menuItem);
                let children;
                if (menuItem.children && menuItem.children.length > 0) {
                    children = this.$formatMenu(menuItem.children);
                }
                if (children && children.length > 0) {
                    item.children = children;
                    if (item.meta.tile) {
                        for (let n = 0; n < children.length; n++) {
                            const child = children[n];
                            list.push(child);
                        }
                    }
                    else {
                        list.push(item);
                    }
                }
                else {
                    list.push(item);
                }
            }
        }
        return list;
    }
    setCurrent(item) {
        if (item.meta.type === 'router') {
            this.current = [item.path];
        }
        else if (item.meta.type === 'url') {
            // openWindow(item.path)
        }
    }
    reset() {
        this.load = 'un';
        this.list = [];
        this.menu = [];
        this.current = [];
    }
}
exports.default = MenuData;
